import { Toaster } from '@src/controls/toasts/toaster';

export class ToastsViewModel {
    info() {
        Toaster.show('Info', 'Hello World!');
    }

    error() {
        Toaster.show('Error', 'Error message');
    }

    success() {
        Toaster.show('Success', 'Success message');
    }
}